import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../assets/js/constants';

const DOT_SIZE = '12px';

const DefaultDot = styled.div`
    width: ${DOT_SIZE};
    height:  ${DOT_SIZE};
    border-radius: 50%;
    background: ${COLORS.darkGrey};
    opacity: ${props => props.active ? 0.8 : 0.2};
    margin: 0 5px;
    cursor: pointer;
    &:hover {
        opacity: ${props => props.active ? 1 : 0.45};
    }
`;

const DotsContainer = styled.div`
    justify-content: center;
    position: absolute;

    ${({ vertical }) =>
        vertical
            ? `
                height: 100%;
                margin-left: 10px;
                right: -30px;
                flex-direction: column;
                
                & ${DefaultDot} {
                    margin: 5px 0;
                }
            `
            : `
                width: 100%;
                margin-top: 10px;
                bottom: 26px;
                z-index: 10;
            `
    }
`;

const DefaultDots = (props) => {
    const { active, count, onClick, vertical = false } = props;
    const dots = [];
    for (let i = 0; i <= count; i++) {
        dots.push(<DefaultDot key={i} active={i === active} onClick={() => onClick(i)}/>);
    }
    return (
        <DotsContainer vertical={vertical}>
            {dots}
        </DotsContainer>
    );
};

export default DefaultDots;
